<!--
    A quebra de linha acontece em `__content` (um nível abaixo do container):
    assim o botão de limpar permanece fixo à direita, sem descer junto com as
    tags quando elas ocupam várias linhas.
-->
<div
    class="ai-tag-input"
    [class.ai-is-disabled]="disabled()"
    (click)="focusInput()"
>
    <div class="ai-tag-input__content">
        @for (tag of tags(); track tag) {
            <span class="ai-tag-input__tag">
                <span class="ai-tag-input__tag-label">{{ tag }}</span>
                @if (!disabled()) {
                    <button
                        type="button"
                        class="ai-tag-input__tag-remove"
                        [attr.aria-label]="'Remover ' + tag"
                        (click)="removeTag(tag)"
                    >
                        <ai-icon [fontIcon]="'fa-solid fa-xmark'" />
                    </button>
                }
            </span>
        }

        <input
            #inputEl
            type="text"
            class="ai-tag-input__field"
            [placeholder]="placeholder()"
            [disabled]="disabled()"
            (keydown)="addTagFromInput($event)"
            (paste)="addTagsFromPaste($event)"
            (blur)="onBlur()"
        />
    </div>

    @if (hasTags() && !disabled()) {
        <button
            type="button"
            class="ai-tag-input__clear"
            aria-label="Limpar tags"
            title="Limpar tags"
            (click)="clearAll($event)"
        >
            <ai-icon [fontIcon]="'fa-solid fa-xmark'" />
        </button>
    }
</div>
